export default __webpack_public_path__ + "static/media/linkedin.28952d76.png";